var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewConversation = function SvgNewConversation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "m7.725 25 2.038-2.032h16.225q.417 0 .708.302a.98.98 0 0 1 .304.72.94.94 0 0 1-.304.707.95.95 0 0 1-.709.303zm-1.266-1.161-2.923 1.123q-.228.088-.418-.113-.177-.19-.088-.417l1.202-2.815 13.82-13.76 2.215 2.221zM21.381 8.992 19.14 6.77l1.278-1.262q.48-.467.974-.505.507-.038.937.391l.43.43q.443.442.418.934t-.519.985z"
  })));
};
export default SvgNewConversation;